import React, {useState} from "react";
import {Checkbox, TableCell} from "@mui/material";
import {CampaignPerson} from "../campaign-person";
import {CampaignPersonService} from "../campaign-person.service";
import {setAlert} from "../../../redux/actions";
import {useDispatch} from "react-redux";

const classes = {
    rowDanger: {
        backgroundColor: '#f2dedeb8'
    },
    rowWarning: {
        backgroundColor: '#fcf8e3'
    },
};

interface AskedCellProps {
    campaignPerson: CampaignPerson;
    disabled?: boolean;
}

const AskedCell = ({campaignPerson, disabled}: AskedCellProps) => {

    const dispatch = useDispatch();
    const [item, setItem] = useState<CampaignPerson>(campaignPerson);

    const rowClassAsked = () => {
        return item.asked ? classes.rowWarning : classes.rowDanger;
    }

    const onChangeAsked = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newAsked = event.target.checked;
        CampaignPersonService.updateAsked(item.id, newAsked).then(() => {
            setItem({
                ...campaignPerson,
                asked: newAsked
            })
            dispatch(setAlert({show: true, message: 'Registro com sucesso', severity: 'success'}));
        }).catch((error) => {
            dispatch(setAlert({
                show: true,
                message: 'Erro ao salvar registro - ' + error.data.message,
                severity: 'error'
            }));
        })
    }

    return (
        <TableCell sx={rowClassAsked} align={"center"}>
            <Checkbox checked={item.asked} onChange={(event) => onChangeAsked(event)} disabled={disabled}/>
        </TableCell>
    )
}

export default React.memo(AskedCell);